(function(angular, module) {var OutcomeComparisonBaseReportController, OutcomeComparisonReportController, ReportColumns, outcomeComparisonStates, resolveComparisonConfig, resolveSingleConfig,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ReportColumns = [
  {
    name: 'completion',
    label: 'Completion',
    percent: 'completion',
    num: 'successful',
    denom: 'exits',
    tooltip: [
      {
        label: 'Completion',
        percent: 'completion',
        desc: 'completion.',
        values: [
          {
            name: 'exits',
            label: 'students exited.'
          }, {
            name: 'successful',
            label: 'successful students'
          }
        ]
      }
    ]
  }, {
    name: 'litnum',
    label: 'Literacy / Numeracy',
    percent: 'litnum',
    num: 'litnum_gain',
    denom: 'litnum_eligible',
    tooltip: [
      {
        label: 'Literacy / Numeracy',
        percent: 'litnum',
        desc: 'with literacy or numeracy gain.',
        values: [
          {
            name: 'litnum_eligible',
            label: 'eligible students.'
          }, {
            name: 'litnum_gain',
            label: 'students with gains.'
          }
        ]
      }, {
        label: 'Reading Grade',
        percent: 'reading',
        desc: 'with reading gain.',
        values: [
          {
            name: 'reading_eligible',
            label: 'eligible students.'
          }, {
            name: 'reading_gain',
            label: 'with reading gains.'
          }
        ]
      }, {
        label: 'Math Grade',
        percent: 'math',
        desc: 'with math gain.',
        values: [
          {
            name: 'math_eligible',
            label: 'eligible students.'
          }, {
            name: 'math_gain',
            label: 'with math gains.'
          }
        ]
      }
    ]
  }, {
    name: 'hse',
    label: 'HSE / Diploma',
    percent: 'credential',
    num: 'hse_earned',
    denom: 'hse_eligible',
    tooltip: [
      {
        label: 'HSE / Diploma',
        percent: 'credential',
        desc: 'earned credential.',
        values: [
          {
            name: 'hse_eligible',
            label: 'students without HSE at entry'
          }, {
            name: 'hse_earned',
            label: 'students earned HSE.'
          }
        ]
      }
    ]
  }, {
    name: 'certification',
    label: 'Certification',
    percent: 'certification',
    num: 'certificate',
    denom: 'students',
    tooltip: [
      {
        label: 'Certification',
        percent: 'certification',
        desc: 'earned a certificate.',
        values: [
          {
            name: 'students',
            label: 'students enrolled.'
          }, {
            name: 'certificate',
            label: 'students earned a certificate.'
          }
        ]
      }
    ]
  }, {
    name: 'placement',
    label: 'Placement',
    percent: 'placed',
    num: 'placed',
    denom: 'exits',
    tooltip: [
      {
        label: 'Placement',
        percent: 'placed',
        desc: 'placed',
        values: [
          {
            name: 'exits',
            label: 'students exited.'
          }, {
            name: 'placed',
            label: 'students placed.'
          }
        ]
      }, {
        label: 'Job Placement',
        percent: 'placed_job',
        desc: 'placed in a job.',
        values: [
          {
            name: 'exits',
            label: 'students exited.'
          }, {
            name: 'placed_job',
            label: 'students placed in job.'
          }
        ]
      }, {
        label: 'Education Placement',
        percent: 'placed_edu',
        desc: 'placed in education.',
        values: [
          {
            name: 'exits',
            label: 'students exited.'
          }, {
            name: 'placed_edu',
            label: 'students placed in education'
          }
        ]
      }
    ]
  }
];

outcomeComparisonStates = function($stateProvider, TagUrl) {
  'ngInject';
  var programUrl, url;
  url = new TagUrl().addTagTypes(['program', 'location', 'participant']).setTagDefault('affiliation', 'all').addExtraParam('page', {
    type: 'int',
    value: 1,
    squash: true
  }).addExtraParam('show-empty', {
    value: 'no',
    squash: true
  }).addExtraParam('sort', 'name');
  programUrl = new TagUrl().addTagTypes(['participant']).addExtraParam('page', {
    type: 'int',
    value: 1,
    squash: true
  }).addExtraParam('show-empty', {
    value: 'no',
    squash: true
  }).addExtraParam('sort', 'name');
  $stateProvider.state('reports.comparison', {
    abstract: true,
    url: url.buildUrl(),
    params: url.params,
    data: {
      tagUrl: url
    },
    reloadOnSearch: false,
    templateUrl: 'reports/outcomeComparison/base',
    controller: 'OutcomeComparisonBaseReportController',
    controllerAs: '$ctrl',
    resolve: {
      program: function() {
        return null;
      },
      config: resolveComparisonConfig
    }
  });
  $stateProvider.state('reports.comparison.value', {
    url: '/:outcome-comparison',
    reloadOnSearch: false,
    templateUrl: 'reports/outcomeComparison/table',
    controller: 'OutcomeComparisonReportController',
    controllerAs: '$ctrl',
    resolve: {
      config: resolveSingleConfig
    }
  });
  $stateProvider.state('program.reports.comparison', {
    url: programUrl.buildUrl(''),
    params: programUrl.params,
    data: {
      tagUrl: programUrl
    },
    reloadOnSearch: false,
    templateUrl: 'reports/outcomeComparison/base',
    controller: 'OutcomeComparisonBaseReportController',
    controllerAs: '$ctrl',
    resolve: {
      config: resolveComparisonConfig
    }
  });
  return $stateProvider.state('program.reports.comparison.value', {
    url: '/:outcome-comparison',
    reloadOnSearch: false,
    templateUrl: 'reports/outcomeComparison/table',
    controller: 'OutcomeComparisonReportController',
    controllerAs: '$ctrl',
    resolve: {
      config: resolveSingleConfig
    }
  });
};

resolveComparisonConfig = function($http, ApiUrl, program) {
  'ngInject';
  var baseUrl, url;
  baseUrl = ApiUrl.partial('reports', 'comparison', 'config');
  url = program ? baseUrl(program.id) : baseUrl();
  return $http.get(url).then(function(result) {
    var i, items, j, len;
    items = result.data.items;
    for (j = 0, len = items.length; j < len; j++) {
      i = items[j];
      items[i.name] = i;
    }
    return items;
  });
};

resolveSingleConfig = function($stateParams, config) {
  'ngInject';
  return config[$stateParams.outcome];
};

OutcomeComparisonBaseReportController = (function() {

  /* @ngInject */
  function OutcomeComparisonBaseReportController($scope, config, program, TagRefreshService, $timeout) {
    this.config = config;
    this.program = program;
    this.refresh = TagRefreshService.bindTagRefreshToScope($scope);
    $timeout((function(_this) {
      return function() {
        return TagRefreshService.bindAddRemoveEvents($scope, _this.tagFilterController);
      };
    })(this));
  }

  return OutcomeComparisonBaseReportController;

})();

OutcomeComparisonReportController = (function() {

  /* @ngInject */
  function OutcomeComparisonReportController($stateParams, $state, $http, ApiUrl, $timeout, $scope, config, program) {
    this.onTagChange = bind(this.onTagChange, this);
    this.loadData = bind(this.loadData, this);
    var baseUrl;
    this.state = $state;
    this.http = $http;
    this.scope = $scope;
    this.config = config;
    this.columns = ReportColumns;
    this.program = program;
    baseUrl = ApiUrl.partial('reports', 'comparison', $stateParams.outcome);
    this.url = program ? baseUrl(program.id) : baseUrl();
    this.sort = $stateParams.sort || 'name';
    this.showEmpties = $stateParams['show-empty'] === 'yes';
    this.loading = true;
    $scope.$on('tagRefresh', this.onTagChange);
    this.triggerLoad = (function(_this) {
      return function() {
        $timeout.cancel(_this.timeoutPromise);
        return _this.timeoutPromise = $timeout(_this.loadData, 100);
      };
    })(this);
    $scope.triggerRefresh();
  }

  OutcomeComparisonReportController.prototype.loadData = function() {
    var params;
    this.loading = true;
    params = angular.extend({}, this.tags, {
      sort: this.sort,
      'show-empty': this.showEmpties ? 'yes' : 'no'
    });
    this.state.go('.', params, {
      location: 'replace'
    });
    return this.http.get(this.url, {
      params: params
    }).then((function(_this) {
      return function(result) {
        _this.loading = false;
        _this.maximums = result.data.maximums;
        _this.data = result.data.items;
        return _this.data.unshift(result.data.totals);
      };
    })(this));
  };

  OutcomeComparisonReportController.prototype.onTagChange = function(event, tags) {
    if (angular.equals(tags, this.tags)) {
      return;
    }
    this.tags = tags;
    return this.triggerLoad();
  };

  OutcomeComparisonReportController.prototype.onSortChange = function() {
    return this.triggerLoad();
  };

  OutcomeComparisonReportController.prototype.toggleTag = function(tag) {
    var event;
    event = tag.selected ? 'removeTag' : 'addTag';
    return this.scope.$emit(event, tag);
  };

  OutcomeComparisonReportController.prototype.toggleEmpties = function() {
    this.showEmpties = !this.showEmpties;
    return this.triggerLoad();
  };

  return OutcomeComparisonReportController;

})();

module.config(outcomeComparisonStates);

module.controller('OutcomeComparisonReportController', OutcomeComparisonReportController);

module.controller('OutcomeComparisonBaseReportController', OutcomeComparisonBaseReportController);
})(angular, angular.module("dybReports"));